"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _LoadingButton = _interopRequireDefault(require("./LoadingButton"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StudyPlanFeedback = ({
  contentType,
  feedback,
  maxLength,
  placeholder,
  isRegenerating,
  onFeedbackChange,
  onSubmit,
  className = ''
}) => {
  const hasFeedback = Boolean(feedback.trim());
  const updateText = `Update ${contentType}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: `mt-4 border rounded p-3 bg-gray-50 ${className}`,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "font-semibold mb-2",
      children: `Update ${contentType} with your feedback`
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "text-sm text-gray-600 mb-2",
      children: `Tell us what you want to change, and we will update the ${contentType}.`
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "relative",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", {
        className: "w-full border border-gray-300 p-2 pb-6 h-24",
        maxLength: maxLength,
        placeholder: placeholder,
        value: feedback,
        onChange: e => onFeedbackChange(e.target.value)
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "absolute bottom-2 right-4 text-xs text-gray-500 pointer-events-none",
        children: [feedback.length, "/", maxLength]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "mt-3",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingButton.default, {
        text: updateText,
        onClick: onSubmit,
        isLoading: isRegenerating,
        disabled: !hasFeedback
      })
    })]
  });
};
var _default = exports.default = StudyPlanFeedback;